module.exports = __webpack_public_path__ + "img/elementwidths_jasa.e9842ba2.png";